var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddQuantityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.99 24.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b31fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.49,0A12.5,12.5,0,1,0,25,12.49,12.49,12.49,0,0,0,12.49,0Zm6.88,13H13.24v6.34a.75.75,0,0,1-1.5,0V13H5.62a.75.75,0,1,1,0-1.5h6.12V5.62a.75.75,0,1,1,1.5,0v5.91h6.13a.75.75,0,0,1,0,1.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddQuantityIcon);
export default __webpack_public_path__ + "static/media/add-quantity-icon.96d76ffd2129f06197461142a201157b.svg";
export { ForwardRef as ReactComponent };